module.exports = __webpack_public_path__ + "img/change-orange.3f5af4eb.svg";